import { render } from "./TheraphyTrendPage.vue?vue&type=template&id=3d2ecb96&ts=true"
import script from "./TheraphyTrendPage.vue?vue&type=script&lang=ts"
export * from "./TheraphyTrendPage.vue?vue&type=script&lang=ts"

import "./TheraphyTrendPage.vue?vue&type=style&index=0&id=3d2ecb96&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Therapy/TheraphyTrendPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d2ecb96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d2ecb96', __exports__)) {
    api.reload('3d2ecb96', __exports__)
  }
  
  module.hot.accept("./TheraphyTrendPage.vue?vue&type=template&id=3d2ecb96&ts=true", () => {
    api.rerender('3d2ecb96', render)
  })

}


export default __exports__